import {
    Form,
    Modal,
    ModalBody,
    ModalHeader,
    Label,
    Input,
    FormGroup,
    ModalFooter,
    Button,
} from 'reactstrap';
import { useState } from 'react';

const AddPimsDependencyModal = (props) => {
    const { isOpen, pims, closeBehavior, addDependencyBehavior } = props;

    const [PimsDependencyToAdd, setPimsDependencyToAdd] = useState({
        pimsId: null,
        minimumPimsVersionId: null,
    });

    const handlePimsDependenciesChange = (e) => {
        setPimsDependencyToAdd({
            ...PimsDependencyToAdd,
            pimsId: e.target.value,
        });
    };

    const handleAddDependency = () => {
        addDependencyBehavior(PimsDependencyToAdd);
        closeBehavior();
    };

    return (
        <Modal isOpen={isOpen} centered className="text-light">
            <ModalHeader>Add Pims Dependency</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label>{'PIMS Dependencies'}</Label>
                        <Input
                            type="select"
                            onChange={handlePimsDependenciesChange}>
                            <option value="">{'--Select a PIMS--'}</option>
                            {pims.map((p) => (
                                <option key={p.id} value={p.id}>
                                    {p.name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => closeBehavior()}>
                    Close
                </Button>
                <Button color="primary" onClick={() => handleAddDependency()}>
                    Add
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddPimsDependencyModal;
